<div class="assembly-order-status-cell-editor__wrapper">
  <mat-select
    [(value)]="value"
    [disabled]="(loading$ | async) || false"
    (selectionChange)="onSelectionChange($event)"
  >
    <mat-option [value]="assemblyOrderStatus.DRAFT">Draft</mat-option>
    <mat-option [value]="assemblyOrderStatus.IN_PROGRESS">In Progress</mat-option>
    <mat-option [value]="assemblyOrderStatus.ISSUED">Issued</mat-option>
    <mat-option [value]="assemblyOrderStatus.PAUSED">Paused</mat-option>
    <mat-option [value]="assemblyOrderStatus.COMPLETED">Completed</mat-option>
  </mat-select>

  <mat-progress-spinner
    *ngIf="loading$ | async"
    class="progress-spinner"
    diameter="16"
    mode="indeterminate"
  ></mat-progress-spinner>
</div>
